import { AfterContentInit, Component, contentChildren, forwardRef, input } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ButtonComponent, IconComponent } from '../base';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'ird-sort',
  templateUrl: './sort.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SortComponent),
      multi: true,
    },
  ],
  imports: [ButtonComponent, MatMenu, IconComponent, MatMenuTrigger],
})
export class SortComponent implements ControlValueAccessor, AfterContentInit {
  protected label = input<string>('');
  private options = contentChildren<MatOption>(MatOption);

  private selectedValue: string;
  private onChange: (value: string) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: string): void {
    this.selectedValue = value;
    this.updateSelection();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngAfterContentInit(): void {
    this.options().forEach((option) => {
      option.onSelectionChange.subscribe(() => {
        this.selectedValue = option.value;
        this.updateSelection();
        this.onChange(option.value);
        this.onTouched();
      });
    });

    this.updateSelection();
  }

  private updateSelection(): void {
    this.options().forEach((option) => {
      if (option.value === this.selectedValue) {
        option.select(false);
      } else {
        option.deselect(false);
      }
    });
  }
}
